
import { CONSTANTS } from '../constants';

export default{
    name: "FAQs",
    data: () => ({
        FAQS: CONSTANTS.FAQS
    }),
}
